module.exports = __webpack_public_path__ + "static/media/like.e49e5e5c.svg";